module.exports = __webpack_public_path__ + "838a111ade4183c46088fe049b36f867.svg";